import sha256 from "crypto-js/sha256";
export default {
  data: () => {
    return {
      form: { user: "", pass: "" },
      loginError: "",
      loading: false
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      const { user: login, pass } = this.form;
      const password = sha256(pass).toString();
      const data = { login, password, socios: true };
      const { status, error } = await this.$store.dispatch("auth", data);
      if (status) {
        this.$router.replace("unidades");
        this.loading = false;
      } else {
        this.loginError = error;
        this.loading = false;
      }
    }
  }
};
